// extracted by mini-css-extract-plugin
export default {"description":"zVNXuPyDPCNL6CN4wPjX5"};